<template>
  <div id="app" >
    <!--<img src="./assets/logo.png">-->
    <!--<transition name="fade" mode="out-in">-->

            <router-view></router-view>

    <!--</transition>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    if (sessionStorage.getItem("store") ) {
      this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })



  },

  methods: {

  }

}
</script>

<style>
  body {
    background-color: #ffffff;
    width: 100%;
    min-height:100%;
    font-size: 12px;
    -webkit-font-smoothing: antialiased;
    font-family: arial,sans-serif;
  }
/*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue


// WEBPACK FOOTER //
// src/App.vue